/**
 * Travel-document HTML is stored as a single contact_text blob (not per-locale).
 * Map known English headings to the active UI language when rendering.
 */
export function localizeTravelDocumentHtml(
  html: string,
  emergenciesLabel: string,
  locale = "en"
): string {
  if (!html) return html;
  if (String(locale).toLowerCase().startsWith("en")) return html;

  return html.replace(/EMERGENCIES\s+IN\s+SPAIN(\s*:)?/gi, (_match, colon = "") => {
    return `${emergenciesLabel}${colon}`;
  });
}

const LUGGAGE_HEADING_ALIASES = new Set([
  "bagage",
  "luggage",
  "equipaje",
  "transport van je bagage",
  "transport van uw bagage",
  "transport of your luggage",
  "transporte de tu equipaje",
  "transporte de su equipaje",
  "transporte de equipaje",
]);

/**
 * The luggage card already has a section title. Strip a leading heading in the
 * CMS HTML when it duplicates that title (or an older bagage/luggage label).
 */
export function stripDuplicateLuggageHeading(html: string, sectionTitle: string): string {
  if (!html) return html;

  const match = html.match(/^\s*<(h[1-6])[^>]*>([\s\S]*?)<\/\1>\s*/i);
  if (!match) return html;

  const headingText = match[2]
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .replace(/:$/, "")
    .trim()
    .toLowerCase();
  const title = sectionTitle.trim().toLowerCase();

  if (headingText === title || LUGGAGE_HEADING_ALIASES.has(headingText)) {
    return html.slice(match[0].length);
  }

  return html;
}
